<template>
  <zt-modal
    :active="cancelRequestSalaryAdvance"
    @close="closeModal"
    max-width="42rem"
    :z-index="200"
    :fullscreen="isMobile"
  >
    <template slot="modal-header">
      <div class="p-4 font-normal text-zt-lg text-center md:text-left">
        {{ $t("message.salaryAdvanceForm.modal.requestTitle") }}
      </div>
    </template>
    <div class="p-10 text-center md:flex md:text-left">
      <div class="md:w-1/4">
        <zt-icon
          name="exclamation-circle-outline"
          class="text-zt-warning"
          :style="{ fontSize: '6rem' }"
        ></zt-icon>
      </div>
      <div class="md:w-3/4">
        <h1 class="text-bold text-xl mb-4 md:mb-3">
          {{ $t("message.salaryAdvanceForm.modal.cancelAdvice") }}
        </h1>
        <div class="text-left">
          <p class="text-zt-dark-500">
            {{ $t("message.salaryAdvanceForm.modal.warning") }}.
          </p>
        </div>
      </div>
    </div>
    <div
      class="zt-modal-footer grey-background border-b flex justify-between p-5 fixed md:relative bottom-0 right-0 left-0"
    >
      <div class="">
        <zt-button
          data-vs-button="active-step"
          class="ml-1 w-11/12"
          color="disabled"
          style="color: #707070 !important"
          @click="closeModal()"
          >{{ $t("message.linkUser.linkAccountModal.cancelButton") }}</zt-button
        >
      </div>
      <div class="">
        <zt-button
          data-vs-button="active-step"
          class="ml-1 w-11/12"
          @click="goToHome()"
          >{{ $t("message.salaryAdvanceForm.modal.confirmCancel") }}</zt-button
        >
      </div>
    </div>
  </zt-modal>
</template>

<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    cancelRequestSalaryAdvance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    goToHome() {
      this.closeModal();
      if (this.$router.currentRoute.name !== "payroll-menu") {
        this.$router.push({ name: "salaryAdvances" });
      }
    },
    closeModal() {
      this.$emit("update:cancelRequestSalaryAdvance", false);
    },
  },
};
</script>
<style scoped>
.grey-background {
  background-color: #ebebeb;
}
</style>
